import { useState } from 'react'
import { User } from '../../types'
import UserAvatar from '../shared/UserAvatar'

interface Props {
  members: User[]
  readOnly?: boolean
}

export default function SectionCheckIn({ members, readOnly }: Props) {
  const [checkedIn, setCheckedIn] = useState<Record<number, boolean>>({})
  const [notes, setNotes] = useState('')

  const toggleCheckIn = (memberId: number) => {
    setCheckedIn(prev => ({ ...prev, [memberId]: !prev[memberId] }))
  }

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl font-semibold text-text-primary tracking-wide uppercase mb-2">Check-In</h3>
        <p className="text-base text-text-muted">What's up?</p>
      </div>

      <div className="space-y-2">
        {/* allow-unsorted-people: do NOT alphabetize. Check-in follows the
            facilitator's custom attendee order set in meeting setup. */}
        {members.map(member => (
          <div
            key={member.id}
            className={`flex items-center gap-3 rounded-lg p-3 cursor-pointer transition-colors ${
              checkedIn[member.id] ? 'bg-status-on-track/10 border border-status-on-track/20' : 'bg-[#F5F5F5]/30 border border-transparent'
            }`}
            onClick={() => !readOnly && toggleCheckIn(member.id)}
          >
            <input
              type="checkbox"
              checked={!!checkedIn[member.id]}
              readOnly
              disabled={readOnly}
              className="w-5 h-5 rounded border-stone/30 text-pinnacle-red focus:ring-pinnacle-red/20 disabled:opacity-50 pointer-events-none"
            />
            <UserAvatar user={member} size="md" />
            <div className="flex-1">
              <p className="font-medium text-text-primary">{member.full_name}</p>
              <p className="text-sm text-text-muted">{checkedIn[member.id] ? 'Checked in' : 'Waiting...'}</p>
            </div>
            {checkedIn[member.id] && (
              <svg className="w-5 h-5 text-status-on-track" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
        ))}
      </div>

      {!readOnly && (
        <div>
          <label className="block text-sm font-medium text-text-primary mb-2">Notes</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Capture any key takeaways from the check-in..."
            className="w-full rounded-lg border border-stone/20 px-4 py-3 text-text-primary placeholder-text-muted focus:outline-none focus:ring-2 focus:ring-pinnacle-red/20 focus:border-pinnacle-red min-h-[80px] resize-y"
          />
        </div>
      )}
    </div>
  )
}
